import { combineActions, handleActions } from 'redux-actions';
import { mapAnswers } from '../helper';
import {
  getQuestionnaireAnswersSuccess,
  getQuestionnaireSuccess,
  hideRecheckModal,
  saveQuestionnaireAnswersFail,
  saveQuestionnaireAnswersRequest,
  saveQuestionnaireAnswersSuccess,
  setCurrentFormIndex,
  setDraftQuestionnaireAnswersFail,
  setDraftQuestionnaireAnswersRequest,
  setDraftQuestionnaireAnswersSuccess,
  showRecheckModal,
} from '../actions';

const defaultState = {
  questions: [],
  currentQuestion: 0,
  answers: [],
  errors: null,
  passed: false,
  loading: false,
  currentStep: null,
};

const cySecQuestionnaire = handleActions(
  {
    [getQuestionnaireSuccess]: (state, { response }) => ({
      ...state,
      questions: response.data,
      currentQuestion: 0,
    }),
    [getQuestionnaireAnswersSuccess]: (state, { response }) => {
      const answers = mapAnswers(response.data);

      return {
        ...state,
        answers: answers,
      };
    },
    [combineActions(setDraftQuestionnaireAnswersRequest, saveQuestionnaireAnswersRequest)]: (
      state,
    ) => {
      return {
        ...state,
        loading: true,
      };
    },
    [combineActions(setDraftQuestionnaireAnswersSuccess, saveQuestionnaireAnswersSuccess)]: (
      state,
      { response },
    ) => {
      const answers = mapAnswers(response.data.answers);

      return {
        ...state,
        loading: false,
        answers: answers,
      };
    },
    [combineActions(setDraftQuestionnaireAnswersFail, saveQuestionnaireAnswersFail)]: (state) => {
      return {
        ...state,
        loading: false,
      };
    },
    [setCurrentFormIndex]: (state, { payload }) => {
      return {
        ...state,
        currentStep: payload,
      };
    },
    [showRecheckModal]: (state) => {
      return {
        ...state,
        showRecheckModal: true,
      };
    },
    [hideRecheckModal]: (state) => {
      return {
        ...state,
        showRecheckModal: false,
      };
    },
  },
  defaultState,
);

export default cySecQuestionnaire;
